module.exports = __webpack_public_path__ + "img/dit.2443109f.svg";